import * as THREE from 'three';
import {PlaneBorder} from "./PlaneBorder";
import {Plane} from "./Plane";
import {textCard} from "../Text/TextCard";
import {Mesh, Object3D} from "three";

export class Card {

    private group: THREE.Group;
    private color: number;
    private borderColor: number;
    private width: number;
    private height: number;
    private radius: number;
    private borderThickness: number;

    constructor(
        isRouter: boolean,
        name: string,
        type: string,
    ){
        this.group = new THREE.Group();
        this.color = 0xffffff;
        this.borderColor = 0xDCDCE9;
        this.width = 3;
        this.height = 1;
        this.radius = 0.25;
        this.borderThickness = 0.02;

        name = name.length > 15 ? name.substring(0, 15) + "..." : name;

        if (isRouter) {
            // Créer le plan principal
            const plane: Mesh = Plane(this.width, this.height, this.radius, this.color);

            // Créer la bordure avec extrusion
            const planeBorder: Object3D = PlaneBorder(this.width, this.height, this.radius, this.borderColor, this.borderThickness);

            this.group.add(plane, planeBorder);
        }

        // Ajout du texte
        textCard(name, 0.23, 0.006, (textMesh: THREE.Mesh): void => {
            textMesh.position.y = 0.15;
            this.group.add(textMesh);
        });

        textCard(capFirstLetter(type), 0.23, 0, (textMesh: THREE.Mesh): void => {
            textMesh.position.y = -0.3;
            this.group.add(textMesh);
        });

    }

    public getGroup(): THREE.Group {
        return this.group;
    }
}

function capFirstLetter(str: string): string {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
}
